import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../config';
import { decrypt, encrypt } from '../utils/encryption';

const api = axios.create({
  baseURL: config.api.url,
});
export default api;

api.interceptors.request.use(async (axiosConfig) => {
  const cookiesList = Cookies.get();
  if (config.auth.cookieName in cookiesList) {
    try {
      const decrypted = decrypt(cookiesList[config.auth.cookieName]);
      const parsed = JSON.parse(decrypted);
      if (parsed?.token && axiosConfig.headers) {
        axiosConfig.headers.authorization = `Bearer ${parsed.token}`;
      }
    } catch (error) {
      console.error('Token error', error);
      Cookies.remove(config.auth.cookieName);
    }
  }
  return axiosConfig;
});

api.interceptors.response.use((response) => {
  const cookiesList = Cookies.get();
  if (config.auth.cookieName in cookiesList) {
    try {
      const cookiesListDecrypted = decrypt(cookiesList[config.auth.cookieName]);
      const cookieParsed = JSON.parse(cookiesListDecrypted);
      const oldToken = cookieParsed.token;
      const oldTokenPayloadBase64 = oldToken.split('.')[1];
      const oldTokenPayload = JSON.parse(atob(oldTokenPayloadBase64));
      const oldTokenExpirationTimeInSeconds = oldTokenPayload.exp;
      cookieParsed.token = response.headers.token;
      const { token } = cookieParsed;
      const payloadBase64 = token.split('.')[1];
      const payload = JSON.parse(atob(payloadBase64));
      const expirationTimeInSeconds = payload.exp;

      if (expirationTimeInSeconds < oldTokenExpirationTimeInSeconds) {
        return response;
      }

      if (!token) return response;

      const cookieValue = encrypt(JSON.stringify(cookieParsed));
      const { cookieName } = config.auth;
      Cookies.set(cookieName, cookieValue);
    } catch (error) {
      console.error('Token error', error);
    }
  }
  return response;
}, (error) => {
  if (error?.response?.status >= 400) {
    if (error.response && error.response.status === 401) {
      Cookies.remove(config.auth.cookieName);
      location.href = '/error?type=unauthorized';
      return Promise.reject(error);
    }
    const message = (error?.response?.status >= 400 && error?.response?.status <= 499)
      ? error?.response?.data?.message
      : 'Server error!';
    console.warn(message);
  }

  return Promise.reject(error);
});
